import { useUnit } from 'effector-react';
import { DownOutlined } from '@ant-design/icons';
import { Button, Space, Tree } from 'antd';
import style from './RegionsTree.module.css';
import {
  $activeModal,
  $investProStartDistricts,
  $regionsDict,
  $showRegionsTree,
  resetProjectModalEv,
} from '../../models/investProModel/index.js';
import {
  $activeRegions,
  changeActiveRegionsEv,
  clearActiveRegionsEv,
} from '../../models/activeFiltersModel/index.js';
import RegionsLayerSelector from './RegionsLayerSelector.jsx';
import { flyTo } from '../../utils/mapbox-utils.js';

function RegionsTree() {
  const districts = useUnit($investProStartDistricts);
  const regionsDict = useUnit($regionsDict);
  const activeRegions = useUnit($activeRegions);
  const changeActiveRegions = useUnit(changeActiveRegionsEv);
  const showRegionsTree = useUnit($showRegionsTree);
  const clearActiveRegions = useUnit(clearActiveRegionsEv);
  const resetProjectModal = useUnit(resetProjectModalEv);

  const onCheck = (nodes, e) => {
    const formChecked = nodes;
    if (e.node.children) {
      const allChildKeys = [];
      e.node.children.forEach((child) => {
        allChildKeys.push(child.key);
        if (child.children) {
          child.children.forEach((grandChild) => {
            allChildKeys.push(grandChild.key);
          });
        }
      });
      if (!formChecked.checked.includes(e.node.key)) {
        formChecked.checked = formChecked.checked.filter(
          (item) => !allChildKeys.includes(item)
        );
      } else {
        formChecked.checked = [...formChecked.checked, ...allChildKeys];
      }
    } else if (formChecked.checked.includes(e.node.key)) {
      if (!e.node.parent.every((item) => formChecked.checked.includes(item))) {
        const temp = formChecked.checked;
        e.node.parent.forEach((item) => {
          if (!temp.includes(item)) {
            temp.push(item);
          }
        });
        formChecked.checked = temp;
      }
    } else {
      const parentKey = e.node.parent[0];
      if (
        formChecked.checked.filter((item) => item.includes(parentKey))
          .length === 1
      ) {
        formChecked.checked = formChecked.checked.filter(
          (item) => !e.node.parent.includes(item)
        );
      }
    }

    // else if (
    //   e.node.parent.some((item) => formChecked.checked.includes(item))
    // ) {
    //   // if (formChecked.checked.length === 2) {
    //   formChecked.checked = formChecked.checked.filter(
    //     (item) => !e.node.parent.includes(item)
    //   );
    //   // }
    // }
    if (window.dotPopups && window.dotPopups.length > 0) {
      window.dotPopups = window.dotPopups.filter((item) => {
        if (!formChecked.checked.includes(item.options.id)) {
          item.remove();
          resetProjectModal();
        }
        return formChecked.checked.includes(item.options.id);
      });
    }

    if (formChecked.checked.includes(e.node.key)) {
      flyTo(regionsDict[e.node.key].center, 7);
    }
    changeActiveRegions(formChecked.checked);
  };

  const selectAll = () => {
    changeActiveRegions(Object.keys(regionsDict));
  };

  const formatData = () => {
    let data = {};
    districts.forEach((district) => {
      if (data[district.properties.lvl_1_code]) {
        data[district.properties.lvl_1_code].push(district);
      } else {
        data[district.properties.lvl_1_code] = [district];
      }
    });

    data = Object.entries(data).map(([key, value]) => {
      return {
        title: regionsDict[key].name,
        key,
        children: value.map((district) => {
          return {
            title: regionsDict[district.properties.lvl_2_code].name,
            key: district.properties.lvl_2_code,
            parent: [key],
          };
        }),
      };
    });

    return data.sort((a, b) => {
      const order = ['г.Астана', 'г.Алматы', 'г.Шымкент'];
      const A = a.title.trim();
      const B = b.title.trim();
      const aCity = A.startsWith('г.');
      const bCity = B.startsWith('г.');

      return aCity && bCity
        ? order.indexOf(A) - order.indexOf(B) || A.localeCompare(B, 'ru')
        : aCity
          ? -1
          : bCity
            ? 1
            : A.localeCompare(B, 'ru');
    });
  };

  return (
    <div
      className={[
        style.regions_tree,
        showRegionsTree ? style.show : style.hide,
        'glass',
      ].join(' ')}
    >
      <div className={style.regions_tree_title}>Регионы</div>
      <RegionsLayerSelector />
      <Space style={{ marginBottom: 10 }}>
        <Button onClick={selectAll} className={style.regions_tree_button}>
          Выбрать все
        </Button>
        <Button
          onClick={clearActiveRegions}
          className={style.regions_tree_button}
        >
          Очистить
        </Button>
      </Space>
      <Tree
        checkedKeys={{
          checked: activeRegions,
          halfChecked: [],
        }}
        treeData={formatData()}
        switcherIcon={<DownOutlined />}
        multiple
        checkable
        selectable={false}
        onCheck={onCheck}
        checkStrictly
      />
    </div>
  );
}

export default RegionsTree;
